































































































































import Vue from 'vue';
import { get } from 'lodash';
import { VBTooltip, BButtonGroup, BDropdown, BDropdownItemButton } from 'bootstrap-vue';
import ZenButton from '@reciprocity/button';
import { ZenEllipsis } from 'zenComponents';
import LoadingState from '@/components/cards/loading_state/LoadingState.vue';
import { loadCommentsList } from '@/utils/crudActions';
import { formatDate } from '@/utils/vue_filters';
import Comments from '@/pages/sor/info/pages/components/comments/Comments.vue';
import Attachments from '@/components/documents/Attachments.vue';
import { ModalSize } from '@/components/zen_modal/types';

import Reviewers from './reviewers/Reviewers.vue';
import {
  fetchRequestInfo,
  fetchUserRole,
  getCSRFToken,
  notifyCurrentUserFetchFail,
  notifyRequestFetchFail,
  notifySubmitFail,
  notifySubmitSuccess,
  reloadPage,
  showOldModalType,
  updateRequestStatus,
} from './EvidenceCollection.effects';
import { RequestInfo } from './types';

export interface Comment {
  canDelete: boolean;
  canEdit: boolean;
  createdAt: string;
  description: string;
  id: number;
  isEdited: boolean;
  modifiedBy: object | null;
  owner: string;
  ownerId: number;
  updatedAt: string;
}

export default Vue.extend({
  name: 'EvidenceCollection',
  components: {
    ZenButton,
    Attachments,
    LoadingState,
    ZenEllipsis,
    Reviewers,
    Comments,
    BButtonGroup,
    BDropdown,
    BDropdownItemButton,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  filters: {
    formatDate,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: <boolean>true,
      error: <boolean>false,

      userRole: <string>'',
      request: <RequestInfo>{},
      attachmentsCount: <number>0,
      comments: <Comment[]>[],

      // TODO:
      // The hackest hack, but I'm not changing internals of the Comments
      // component right now. Remove this after the Comments component
      // correctly manages it's internal state for comments list so it
      // refreshes without needind a component rerender or a page refresh 🙄
      rerenderComments: <boolean>false,
    };
  },
  computed: {
    csrfToken(): string {
      return this.getCSRFToken(this.$store);
    },
    displayReviewersMessage(): boolean {
      const successfulyLoaded: boolean = !this.loading && !this.error;
      return successfulyLoaded;
    },
    disabledSubmit(): boolean {
      return this.attachmentsCount == 0;
    },
  },
  watch: {
    userRole: function(userRole: string) {
      this.checkPermission(userRole);
    },
    request: function(request) {
      this.checkRequestStatus(request);
    },
  },
  async created() {
    this.$emit('updateConfig', { size: ModalSize.Large });
    await this.fetchCurrentUser();
    await this.fetchData();
    await this.fetchComments();
  },
  methods: {
    getCSRFToken,
    fetchUserRole,
    fetchRequestInfo,
    updateRequestStatus,
    notifyCurrentUserFetchFail,
    notifyRequestFetchFail,
    notifySubmitFail,
    notifySubmitSuccess,
    showOldModalType,
    reloadPage,
    refreshComments() {
      this.fetchComments();
      this.rerenderComments = !this.rerenderComments;
    },
    handleExtended() {
      const url = `/sor/info/${this.type}/${this.id}/info`;
      window.open(url, '_blank');
    },
    async fetchCurrentUser() {
      const { result, error } = await this.fetchUserRole();
      const userRole: string = get(result, 'data.currentUser.userRole.value', '');

      if (error || !userRole) {
        this.error = error;
        this.notifyCurrentUserFetchFail(this.$store);
        return;
      }

      this.userRole = userRole;
    },
    async fetchData() {
      // We pass Request's UUID to GQL call
      const requestId: string = `${this.type}:${this.id}`;

      const { result, error } = await this.fetchRequestInfo(requestId);

      this.loading = false;

      if (error || !result) {
        this.error = error;
        this.notifyRequestFetchFail(this.$store);
        return;
      }

      this.request = result.data;
    },
    // TODO: temp, put in Comments component
    async fetchComments() {
      const data = (await loadCommentsList({ csrf: this.csrfToken, type: 'Request', id: Number(this.id) })).comments;
      this.comments = data;
    },
    checkPermission(userRole: string) {
      if (userRole !== 'Contributor') {
        this.error = true;
        this.showOldModalType(this.$store, { type: this.type, id: this.id });
      }
    },
    checkRequestStatus(request) {
      if (request.node.status.value !== 'Open') {
        this.error = true;
        this.showOldModalType(this.$store, { type: this.type, id: this.id });
      }
    },
    updateAttachmentsCount(count: number) {
      this.attachmentsCount = count;
    },
    async submitEvidence() {
      const { result, error } = await this.updateRequestStatus(`${this.id}`, 'Submitted', this.csrfToken);

      if (error || !result) {
        this.notifySubmitFail(this.$store);
        return;
      }

      this.notifySubmitSuccess(this.$store);
      this.reloadPage(this.$store);
    },
    // TODO: temp, put in Comments component
    scrollToBottom(): void {
      const el = this.$el.getElementsByClassName('comments-wrapper')[0];
      if (el && el.scrollTop != el.scrollHeight) {
        el.scrollTop = el.scrollHeight;
      }
    },
  },
});
